import { render, staticRenderFns } from "./UsuarioInputAutocomplete.vue?vue&type=template&id=059474b6&"
import script from "./UsuarioInputAutocomplete.vue?vue&type=script&lang=js&"
export * from "./UsuarioInputAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports